import { render, staticRenderFns } from "./armazenamento.vue?vue&type=template&id=3cf6b7da"
import script from "./armazenamento.vue?vue&type=script&lang=js"
export * from "./armazenamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports